export default function formatPhone(num) {
  if (num && num.length === 10) {
    return `(${num.substr(0, 3)}) ${num.substr(3, 3)}-${num.substr(6, 4)}`;
  } else {
    return num;
  }
}
